window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.Andrea_Side_Neutral_Open = function() {
	this.initialize(img.MainAssets_Andrea_Side_Neutral_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,461,664);


(lib.Background_Blue = function() {
	this.initialize(img.MainAssets_Background_Blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,977,2052);


(lib.Balloon01 = function() {
	this.initialize(img.MainAssets_Balloon01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1022,517);


(lib.bubbles = function() {
	this.initialize(img.MainAssets_bubbles);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,241,297);


(lib.Button_disabled = function() {
	this.initialize(img.MainAssets_Button_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_down = function() {
	this.initialize(img.MainAssets_Button_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_up = function() {
	this.initialize(img.MainAssets_Button_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.ButtonFat_disabled = function() {
	this.initialize(img.MainAssets_ButtonFat_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,442,178);


(lib.ButtonFat_down = function() {
	this.initialize(img.MainAssets_ButtonFat_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,442,178);


(lib.ButtonFat_up = function() {
	this.initialize(img.MainAssets_ButtonFat_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,442,178);


(lib.CharacterShadow = function() {
	this.initialize(img.MainAssets_CharacterShadow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,294,163);


(lib.DialogButton_down = function() {
	this.initialize(img.MainAssets_DialogButton_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1026,162);


(lib.DialogButton_up = function() {
	this.initialize(img.MainAssets_DialogButton_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1026,162);


(lib.Episode1Image = function() {
	this.initialize(img.MainAssets_Episode1Image);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,313,213);


(lib.Episode1ImageDone = function() {
	this.initialize(img.MainAssets_Episode1ImageDone);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,313,213);


(lib.Episode2Image = function() {
	this.initialize(img.MainAssets_Episode2Image);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,213);


(lib.Episode2ImageDone = function() {
	this.initialize(img.MainAssets_Episode2ImageDone);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,296,213);


(lib.episode3Image = function() {
	this.initialize(img.MainAssets_episode3Image);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,322,224);


(lib.Episode3ImageDOne = function() {
	this.initialize(img.MainAssets_Episode3ImageDOne);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,322,224);


(lib.Episode4Image = function() {
	this.initialize(img.MainAssets_Episode4Image);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,285,186);


(lib.Episode4ImageDone = function() {
	this.initialize(img.MainAssets_Episode4ImageDone);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,285,186);


(lib.Episode5Image = function() {
	this.initialize(img.MainAssets_Episode5Image);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,189,222);


(lib.Episode5ImageDone = function() {
	this.initialize(img.MainAssets_Episode5ImageDone);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,189,222);


(lib.EpisodeSelectButtonHi = function() {
	this.initialize(img.MainAssets_EpisodeSelectButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1192,242);


(lib.EpisodeSelectButtonUp = function() {
	this.initialize(img.MainAssets_EpisodeSelectButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1192,242);


(lib.Eye_Front_Open = function() {
	this.initialize(img.MainAssets_Eye_Front_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,32,36);


(lib.factory1 = function() {
	this.initialize(img.MainAssets_factory1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1278,993);


(lib.factory2 = function() {
	this.initialize(img.MainAssets_factory2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,435,917);


(lib.factory3 = function() {
	this.initialize(img.MainAssets_factory3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,139,1170);


(lib.factory4 = function() {
	this.initialize(img.MainAssets_factory4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,796,1573);


(lib.factory7 = function() {
	this.initialize(img.MainAssets_factory7);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1452,1882);


(lib.FeedbackPopup_Left = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Left);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,75);


(lib.FeedbackPopup_Middle = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Middle);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,126,75);


(lib.FeedbackPopup_Right = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Right);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,75);


(lib.FeedbackPopupBG_dark_1 = function() {
	this.initialize(img.MainAssets_FeedbackPopupBG_dark_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,226,75);


(lib.gambit = function() {
	this.initialize(img.MainAssets_gambit);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,492,657);


(lib.gambit_1 = function() {
	this.initialize(img.MainAssets_gambit_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,232,310);


(lib.Gambit_Back = function() {
	this.initialize(img.MainAssets_Gambit_Back);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,930,1113);


(lib.gambit_closed = function() {
	this.initialize(img.MainAssets_gambit_closed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,492,657);


(lib.gambitWalking2 = function() {
	this.initialize(img.MainAssets_gambitWalking2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,493,617);


(lib.Ground_Iso = function() {
	this.initialize(img.MainAssets_Ground_Iso);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1335,1539);


(lib.Ground_Straight = function() {
	this.initialize(img.MainAssets_Ground_Straight);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1334,1568);


(lib.IntrospectionButton = function() {
	this.initialize(img.MainAssets_IntrospectionButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1304,457);


(lib.IntrospectionButtonDown = function() {
	this.initialize(img.MainAssets_IntrospectionButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1304,457);


(lib.Man1_Brow = function() {
	this.initialize(img.MainAssets_Man1_Brow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,52,10);


(lib.Man1_Front_Base = function() {
	this.initialize(img.MainAssets_Man1_Front_Base);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,441,655);


(lib.MCOptionHi = function() {
	this.initialize(img.MainAssets_MCOptionHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,637,458);


(lib.MCOptionUp = function() {
	this.initialize(img.MainAssets_MCOptionUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,637,458);


(lib.MCOptionVinkje = function() {
	this.initialize(img.MainAssets_MCOptionVinkje);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,84,84);


(lib.Megan_Side_Neutral_Open = function() {
	this.initialize(img.MainAssets_Megan_Side_Neutral_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,553,664);


(lib.Narration01 = function() {
	this.initialize(img.MainAssets_Narration01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1200,359);


(lib.Paul_Side_Neutral_Open = function() {
	this.initialize(img.MainAssets_Paul_Side_Neutral_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,462,664);


(lib.PrevNextButton = function() {
	this.initialize(img.MainAssets_PrevNextButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_disabled = function() {
	this.initialize(img.MainAssets_PrevNextButton_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_down = function() {
	this.initialize(img.MainAssets_PrevNextButton_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.ProgressDot = function() {
	this.initialize(img.MainAssets_ProgressDot);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,31,31);


(lib.ProgressDot_Selected = function() {
	this.initialize(img.MainAssets_ProgressDot_Selected);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,31,31);


(lib.Robert_Side_Neutral_Open = function() {
	this.initialize(img.MainAssets_Robert_Side_Neutral_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,462,663);


(lib.Shadow_Front = function() {
	this.initialize(img.MainAssets_Shadow_Front);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,700,741);


(lib.tabButtonLeft = function() {
	this.initialize(img.MainAssets_tabButtonLeft);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,196,110);


(lib.tabButtonLeftDisabled = function() {
	this.initialize(img.MainAssets_tabButtonLeftDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,196,110);


(lib.tabButtonLeftHi = function() {
	this.initialize(img.MainAssets_tabButtonLeftHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,196,110);


(lib.tabButtonRight = function() {
	this.initialize(img.MainAssets_tabButtonRight);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,196,110);


(lib.tabButtonRightDisabled = function() {
	this.initialize(img.MainAssets_tabButtonRightDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,196,110);


(lib.tabButtonRightHi = function() {
	this.initialize(img.MainAssets_tabButtonRightHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,196,110);


(lib.tabCastIcon = function() {
	this.initialize(img.MainAssets_tabCastIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,100,116);


(lib.tabpanelLeft = function() {
	this.initialize(img.MainAssets_tabpanelLeft);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1286,2300);


(lib.tabpanelRight = function() {
	this.initialize(img.MainAssets_tabpanelRight);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1286,2300);


(lib.tabStoryIcon = function() {
	this.initialize(img.MainAssets_tabStoryIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,100,116);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.IntrospectionThoughtBubbles = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.bubbles();
	this.instance.setTransform(0,11);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.IntrospectionThoughtBubbles, new cjs.Rectangle(0,11,241,297), null);


(lib.ConversationScalableButtonUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("max 3 lines, lines will vertically centeredddddddd", "41px 'Roboto'", "#333333");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 59;
	this.textfield.lineWidth = 888;
	this.textfield.parent = this;
	this.textfield.setTransform(72.9,52);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg
	this.instance = new lib.DialogButton_up();
	this.instance.setTransform(5,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationScalableButtonUp, new cjs.Rectangle(5,0,1026,162), null);


(lib.ConversationScalableButtonOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("max 3 lines, lines will vertically centeredddddddd", "41px 'Roboto'", "#333333");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 59;
	this.textfield.lineWidth = 888;
	this.textfield.parent = this;
	this.textfield.setTransform(72.9,52);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg
	this.instance = new lib.DialogButton_down();
	this.instance.setTransform(5,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationScalableButtonOver, new cjs.Rectangle(5,0,1026,162), null);


(lib.ConversationScalableButtonDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("max 3 lines, lines will vertically centeredddddddd", "41px 'Roboto'", "#333333");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 59;
	this.textfield.lineWidth = 888;
	this.textfield.parent = this;
	this.textfield.setTransform(72.9,52);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg
	this.instance = new lib.DialogButton_down();
	this.instance.setTransform(5,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationScalableButtonDown, new cjs.Rectangle(5,0,1026,162), null);


(lib.ConversationScalableButtonDisabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("max 3 lines, lines will vertically centeredddddddd", "41px 'Roboto'", "#333333");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 59;
	this.textfield.lineWidth = 888;
	this.textfield.alpha = 0.49803922;
	this.textfield.parent = this;
	this.textfield.setTransform(72.9,52);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg
	this.instance = new lib.DialogButton_up();
	this.instance.setTransform(5,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationScalableButtonDisabled, new cjs.Rectangle(5,0,1026,162), null);


(lib.buttonHitArea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(191,191,191,0)").ss(1,1,1).p("Eg77gWXMB33AAAQF1AAEHEIQEIEIAAF0IAAQnQAAF0kIEIQkHEIl1AAMh33AAAQl1AAkIkIQkHkIAAl0IAAwnQAAl0EHkIQEIkIF1AAg");
	this.shape.setTransform(464.2649,126.303,0.9829,0.8905);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(51,51,51,0.008)").s().p("Eg77AWYQl1AAkIkIQkHkIAAl0IAAwnQAAl0EHkIQEIkIF1AAMB33AAAQF1AAEHEIQEIEIAAF0IAAQnQAAF0kIEIQkHEIl1AAg");
	this.shape_1.setTransform(464.2649,126.303,0.9829,0.8905);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.buttonHitArea, new cjs.Rectangle(-2.2,-2.2,933,257), null);


(lib.GambitWWalking = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.gambitWalking2();
	this.instance.setTransform(107.65,-297,0.4871,0.4871,0,0,180);

	this.instance_1 = new lib.gambit_closed();
	this.instance_1.setTransform(107.65,-297,0.4871,0.4871,0,0,180);

	this.instance_2 = new lib.gambit();
	this.instance_2.setTransform(107.65,-297,0.4871,0.4871,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},189).to({state:[{t:this.instance_2}]},10).to({state:[{t:this.instance_2}]},300).wait(1));

	// Layer_2
	this.instance_3 = new lib.CharacterShadow();
	this.instance_3.setTransform(-147,-82);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(500));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-147,-297,294,378);


(lib.Gambit = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.gambit();
	this.instance.setTransform(107.65,-297,0.4871,0.4871,0,0,180);

	this.instance_1 = new lib.gambit_closed();
	this.instance_1.setTransform(107.65,-297,0.4871,0.4871,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},189).to({state:[{t:this.instance}]},10).to({state:[{t:this.instance}]},300).wait(1));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow();
	this.instance_2.setTransform(-147,-82);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(500));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-147,-297,294,378);


(lib.Eyes_Blinking = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Eye_Front_Open();
	this.instance.setTransform(44,-18);

	this.instance_1 = new lib.Eye_Front_Open();
	this.instance_1.setTransform(-76,-18);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1,p:{scaleY:1,y:-18}},{t:this.instance,p:{scaleY:1,y:-18}}]}).to({state:[{t:this.instance_1,p:{scaleY:0.1389,y:-3}},{t:this.instance,p:{scaleY:0.1389,y:-3}}]},119).to({state:[{t:this.instance_1,p:{scaleY:1,y:-18}},{t:this.instance,p:{scaleY:1,y:-18}}]},10).to({state:[{t:this.instance_1,p:{scaleY:1,y:-18}},{t:this.instance,p:{scaleY:1,y:-18}}]},370).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-76,-18,152,36);


(lib.EpisodeImages = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {episode1:0,episode2:1,episode3:2,episode4:3,episode5:4,episode1Disabled:5,episode2Disabled:6,episode3Disabled:7,episode4Disabled:8,episode5Disabled:9};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Episode1Image();
	this.instance.setTransform(-168,-104);

	this.instance_1 = new lib.Episode2Image();
	this.instance_1.setTransform(-174,-115);

	this.instance_2 = new lib.episode3Image();
	this.instance_2.setTransform(-161,-112);

	this.instance_3 = new lib.Episode4Image();
	this.instance_3.setTransform(-153,-87);

	this.instance_4 = new lib.Episode5Image();
	this.instance_4.setTransform(-106,-112);

	this.instance_5 = new lib.Episode1ImageDone();
	this.instance_5.setTransform(-168,-104);

	this.instance_6 = new lib.Episode2ImageDone();
	this.instance_6.setTransform(-174,-115);

	this.instance_7 = new lib.Episode3ImageDOne();
	this.instance_7.setTransform(-161,-112);

	this.instance_8 = new lib.Episode4ImageDone();
	this.instance_8.setTransform(-153,-87);

	this.instance_9 = new lib.Episode5ImageDone();
	this.instance_9.setTransform(-106,-112);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_9}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-174,-115,335,227);


(lib.chimney = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.factory3();
	this.instance.setTransform(-69.5,-585);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.chimney, new cjs.Rectangle(-69.5,-585,139,1170), null);


(lib.BalloonNPCtutorial = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.bodyTextfield = new cjs.Text("NPC text here eiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii\nLine2\nLine3\netc\nLine5\nLine6", "40px 'Roboto Medium'", "#333333");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 50;
	this.bodyTextfield.lineWidth = 968;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-475.3,-261.2);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.instance = new lib.Balloon01();
	this.instance.setTransform(-499,-294);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.bodyTextfield}]}).wait(1));

	// Layer_4
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("AgeAgIA9g9IgLgC");
	this.shape.setTransform(289.85,-277.125);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BalloonNPCtutorial, new cjs.Rectangle(-499,-294,1022,517), null);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.BioRobert = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Robert_Side_Neutral_Open();
	this.instance.setTransform(-58,-186,0.2922,0.2922);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bioTextfield
	this.bioTextfield = new cjs.Text("This is you! A senior employee at Life is Sweet and team leader of Team Chocolatexxxx", "40px 'Roboto'", "#333333");
	this.bioTextfield.name = "bioTextfield";
	this.bioTextfield.lineHeight = 58;
	this.bioTextfield.lineWidth = 553;
	this.bioTextfield.parent = this;
	this.bioTextfield.setTransform(135.4438,-182.951);
ranj.TextOffsetFixer.fix(this.bioTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bioTextfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BioRobert, new cjs.Rectangle(-58,-186,748.3,231.1), null);


(lib.BioMegan = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Megan_Side_Neutral_Open();
	this.instance.setTransform(-58,-186,0.2922,0.2922);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bioTextfield
	this.bioTextfield = new cjs.Text("This is you! A senior employee at Life is Sweet and team leader of Team Chocolatexxxx", "40px 'Roboto'", "#333333");
	this.bioTextfield.name = "bioTextfield";
	this.bioTextfield.lineHeight = 58;
	this.bioTextfield.lineWidth = 553;
	this.bioTextfield.parent = this;
	this.bioTextfield.setTransform(135.4438,-182.951);
ranj.TextOffsetFixer.fix(this.bioTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bioTextfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BioMegan, new cjs.Rectangle(-58,-186,748.3,194), null);


(lib.BioJames = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Paul_Side_Neutral_Open();
	this.instance.setTransform(-58,-186,0.2922,0.2922);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bioTextfield
	this.bioTextfield = new cjs.Text("This is you! A senior employee at Life is Sweet and team leader of Team Chocolatexxxx", "40px 'Roboto'", "#333333");
	this.bioTextfield.name = "bioTextfield";
	this.bioTextfield.lineHeight = 58;
	this.bioTextfield.lineWidth = 553;
	this.bioTextfield.parent = this;
	this.bioTextfield.setTransform(135.4438,-182.951);
ranj.TextOffsetFixer.fix(this.bioTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bioTextfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BioJames, new cjs.Rectangle(-58,-186,748.3,194), null);


(lib.BioGambit = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.gambit_1();
	this.instance.setTransform(70.2,-186,0.6,0.6,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bioTextfield
	this.bioTextfield = new cjs.Text("This is you! A senior employee at Life is Sweet and team leader of Team Chocolatexxxx", "40px 'Roboto'", "#333333");
	this.bioTextfield.name = "bioTextfield";
	this.bioTextfield.lineHeight = 58;
	this.bioTextfield.lineWidth = 553;
	this.bioTextfield.parent = this;
	this.bioTextfield.setTransform(135.4438,-182.951);
ranj.TextOffsetFixer.fix(this.bioTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bioTextfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BioGambit, new cjs.Rectangle(-69,-186,759.3,193.3), null);


(lib.BioEllis = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Andrea_Side_Neutral_Open();
	this.instance.setTransform(-58,-186,0.2922,0.2922);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bioTextfield
	this.bioTextfield = new cjs.Text("This is you! A senior employee at Life is Sweet and team leader of Team Chocolatexxxx", "40px 'Roboto'", "#333333");
	this.bioTextfield.name = "bioTextfield";
	this.bioTextfield.lineHeight = 58;
	this.bioTextfield.lineWidth = 553;
	this.bioTextfield.parent = this;
	this.bioTextfield.setTransform(135.4438,-182.951);
ranj.TextOffsetFixer.fix(this.bioTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bioTextfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BioEllis, new cjs.Rectangle(-58,-186,748.3,194), null);


(lib.TutorialButtonHitarea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("ApkC3IAAltITJAAIAAFtg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialButtonHitarea, new cjs.Rectangle(-61.2,-18.2,122.5,36.5), null);


(lib.TutorialBackgroundScore = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// cutout BITMAPS
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(58,58,58,0)").ss(1,1,1).p("EhoagwrIAbAAMDQaAAAIAAHQMAAABaHMjQ1AAAg");
	this.shape.setTransform(-1.95,1503.225);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("rgba(64,64,64,0)").ss(1,1,1).p("Aq7o+IV3AAQB8AABYBYQBYBYAAB8IAAIlQAAB8hYBYQhYBYh8AAI13AAQh8AAhYhYQhYhYAAh8IAAolQAAh8BYhYQBYhYB8AAg");
	this.shape_1.setTransform(-418.15,-806.1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("rgba(0,255,0,0)").s().p("Aq7I/Qh8AAhYhYQhYhYAAh8IAAolQAAh8BYhYQBYhYB8AAIV3AAQB8AABYBYQBYBYAAB8IAAIlQAAB8hYBYQhYBYh8AAg");
	this.shape_2.setTransform(416.75,-806.1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#4A4A4A").s().p("EhogEdtMAAAhhYIAcAAMAAAl4pIgcAAMAAAhhYMDQ1AAAMAAABeaIAMAAMAAAGC3IgMAAIAAnQMjQZAAAMDQZAAAIAAHQMAAABaIgEAzFiDaQhYBYAAB8IAAImQAAB8BYBYQBYBYB8AAIV4AAQB8AABYhYQBYhYAAh8IAAomQAAh8hYhYQhYhYh8AAI14AAQh8AAhYBYgEhQvh3gQAAB8BYBYQBYBYB8AAIV4AAQB8AABYhYQBYhYAAh8IAAomQAAh8hYhYQhYhYh8AAI14AAIV4AAQB8AABYBYQBYBYAAB8IAAImQAAB8hYBYQhYBYh8AAI14AAQh8AAhYhYQhYhYAAh8IAAomQAAh8BYhYQBYhYB8AAQh8AAhYBYQhYBYAAB8IAAImg");
	this.shape_3.setTransform(-1.375,-13.675);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundScore, new cjs.Rectangle(-671.2,-1842.2,1338.7,3658.1000000000004), null);


(lib.TutorialBackgroundCharacter = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// cutout BITMAPS
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(58,58,58,0)").ss(1,1,1).p("EhouguiIAcAAMDQlAAAIAcAAMAAABdFMjRdAAAg");
	this.shape.setTransform(0.025,1524.7375);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("rgba(64,64,64,0)").ss(1,1,1).p("Aq7o+IV3AAQB8AABYBYQBYBYAAB8IAAIlQAAB8hYBYQhYBYh8AAI13AAQh8AAhYhYQhYhYAAh8IAAolQAAh8BYhYQBYhYB8AAg");
	this.shape_1.setTransform(-418.15,-806.1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#4A4A4A").s().p("EhoTEZ2MAAAhdGIAcAAMDQlgABIAcABMAAABdGgEhn3jAuIhSAAMAAAhZHMDRTAAAMAAABVdIAkAAMAAAGBHMjQlAABgEhPKiIgQhYBYAAB8IAAImQAAB8BYBYQBYBYB8AAIV4AAQB8AABYhYQBYhYAAh8IAAomQAAh8hYhYQhYhYh8AAI14AAQh8AAhYBYg");
	this.shape_2.setTransform(-2.675,18.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundCharacter, new cjs.Rectangle(-675.6,-1784.8,1346.9,3608.5), null);


(lib.TutorialBackgroundBird = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Background
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#4A4A4A").s().p("EhpBDDUMAAAg7UIBNAAMAAAkP/IhNAAMAAAg7UMDSDAAAMAAAA7UIglAAMAAAEP/IAlAAMAAAA7UgEhRrgHvMAAABPmQADBkCTAAMCfMAAAQCSAAAEhkMAAAhPmQgDhliTAAMifMAAAQiTAAgDBlg");
	this.shape.setTransform(-1.95,193.525);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(58,58,58,0)").s().p("EhPmApYQiSAAgEhkMAAAhPmQAEhlCSAAMCfNAAAQCSAAAEBlMAAABPmQgEBkiSAAg");
	this.shape_1.setTransform(-0.325,398.625);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundBird, new cjs.Rectangle(-675.1,-1747.2,1346.4,3190.7), null);


(lib.ProgressDotTween = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ProgressDot();
	this.instance.setTransform(-15.5,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15.5,-15.5,31,31);


(lib.Dot = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ProgressDot_Selected();
	this.instance.setTransform(-15.5,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15.5,-15.5,31,31);


(lib.PlaceholderRound = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		this.removeChildAt(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AifCgIAAk/IE/AAIAAE/g");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlaceholderRound, new cjs.Rectangle(-16,-16,32,32), null);


(lib.IntroScreenTexts = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// titleTextField
	this.titleTextfield = new cjs.Text("Life is Sweet", "108px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 130;
	this.titleTextfield.lineWidth = 867;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-437.8,-769.45);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).to({_off:true},1).wait(2));

	// bodyTextField
	this.bodyTextfield = new cjs.Text("In this game you help a team develop new chocolate products at a big candy manufacturer.\n\nYou and your team will face various challenges. Pick the options that are closest to what you would do in order to deal with them.", "40px 'Roboto'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 65;
	this.bodyTextfield.lineWidth = 879;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-437.8,-580.602);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1).to({y:-698.552,text:"xIn this game, you work at the Headquarters of an international confectionery company."},0).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-439.8,-771.4,882.5,698.8);


(lib.FeedbackPopupBG_Right = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Right();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Right, new cjs.Rectangle(0,0,50,75), null);


(lib.FeedbackPopupBG_Middle = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Middle();
	this.instance.setTransform(-2,0,1.0482,1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Middle, new cjs.Rectangle(-2,0,132.1,75), null);


(lib.FeedbackPopupBG_Left = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Left();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Left, new cjs.Rectangle(0,0,50,75), null);


(lib.FeedbackPopupBG_dark = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1 BITMAPS
	this.instance = new lib.FeedbackPopupBG_dark_1();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_dark, new cjs.Rectangle(0,0,226,75), null);


(lib.factory7_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.factory7();
	this.instance.setTransform(-726,-941);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.factory7_1, new cjs.Rectangle(-726,-941,1452,1882), null);


(lib.factory4_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.factory4();
	this.instance.setTransform(-398,-786.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.factory4_1, new cjs.Rectangle(-398,-786.5,796,1573), null);


(lib.factory3_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.factory2();
	this.instance.setTransform(-217.5,-458.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.factory3_1, new cjs.Rectangle(-217.5,-458.5,435,917), null);


(lib.factory1_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.factory1();
	this.instance.setTransform(-596.5,-520.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.factory1_1, new cjs.Rectangle(-596.5,-520.5,1278,993), null);


(lib.DarkTransparentBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(35,32,33,0.4)").s().p("EhpiC7xMAAAl3hMDTFAAAMAAAF3hg");
	this.shape.setTransform(-0.025,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DarkTransparentBackground, new cjs.Rectangle(-675.5,-1201.7,1351,2403.4), null);


(lib.StoryTabButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.instance = new lib.tabStoryIcon();
	this.instance.setTransform(-22,-28,0.4828,0.4828);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// Layer_3
	this.instance_1 = new lib.tabButtonRight();
	this.instance_1.setTransform(-54,-31,0.5546,0.5546);

	this.instance_2 = new lib.tabButtonRightHi();
	this.instance_2.setTransform(-54,-31,0.5546,0.5546);

	this.instance_3 = new lib.tabButtonRightDisabled();
	this.instance_3.setTransform(-54,-31,0.5546,0.5546);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-100,-55,200,122.3);


(lib.StartGameButtonFat = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 19;
	this.upLabelTextField.lineWidth = 126;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-0.3,-11.85);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 19;
	this.overLabelTextField.lineWidth = 126;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-0.3,-11.85);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 19;
	this.downLabelTextField.lineWidth = 126;
	this.downLabelTextField.alpha = 0.49803922;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-0.3,-11.85);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 19;
	this.disabledLabelTextField.lineWidth = 126;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-0.3,-11.85);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.ButtonFat_up();
	this.instance.setTransform(-82,-25,0.3683,0.3683);

	this.instance_1 = new lib.ButtonFat_down();
	this.instance_1.setTransform(-82,-25,0.3683,0.3683);

	this.instance_2 = new lib.ButtonFat_disabled();
	this.instance_2.setTransform(-82,-25,0.3683,0.3683);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-82,-25,162.8,65.6);


(lib.StartGameButton_Overlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Start\nStart", "16px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 14;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.05,-18.3);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Start\nStart", "16px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 14;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.05,-18.3);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Start\nStart", "16px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 14;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.05,-18.3);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Start\nStart", "16px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 14;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.05,-18.3);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-34.6,0.4,0.4323);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-34.85,0.4,0.4323);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-34.6,0.4,0.4323);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1,p:{y:-34.85}}]},1).to({state:[{t:this.instance_1,p:{y:-34.4}}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-34.8,173.2,73.9);


(lib.StartGameButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField = new cjs.Text("Start", "22px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 26;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.05,-14.75);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Start", "22px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 26;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.05,-14.75);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Start", "22px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 26;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.05,-14.75);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Start", "22px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 26;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.05,-14.75);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-30.9,0.4,0.3999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-30.9,173.2,68);


(lib.CastTabButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.instance = new lib.tabCastIcon();
	this.instance.setTransform(-24,-28,0.4828,0.4828);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// Layer_3
	this.instance_1 = new lib.tabButtonLeft();
	this.instance_1.setTransform(-54,-31,0.5546,0.5546);

	this.instance_2 = new lib.tabButtonLeftHi();
	this.instance_2.setTransform(-54,-31,0.5546,0.5546);

	this.instance_3 = new lib.tabButtonLeftDisabled();
	this.instance_3.setTransform(-54,-31,0.5546,0.5546);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-100,-55,200,122.3);


(lib.bg_grey = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#232021").s().p("EhpxCmgMAAAlM/MDTjAAAMAAAFM/g");
	this.shape.setTransform(-0.025,-0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.bg_grey, new cjs.Rectangle(-677,-1065.6,1354,2131.2), null);


(lib.BalloonNPC = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.bodyTextfield = new cjs.Text("NPC text here eiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii\nLine2\nLine3\netc\nLine5\nLine6", "40px 'Roboto Medium'", "#333333");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 50;
	this.bodyTextfield.lineWidth = 968;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-475.3,-261.2);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.instance = new lib.Balloon01();
	this.instance.setTransform(-499,-294);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("AgeAgIA9g9IgLgC");
	this.shape.setTransform(289.85,-277.125);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance},{t:this.bodyTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BalloonNPC, new cjs.Rectangle(-499,-294,1022,517), null);


(lib.BalloonInfoBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Narration01();
	this.instance.setTransform(-509.95,-152.55,0.85,0.8501);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BalloonInfoBG, new cjs.Rectangle(-509.9,-152.5,1019.9,305.1), null);


(lib.Background_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Background_Blue();
	this.instance.setTransform(-667,-1054,1.3643,1.0273);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background_1, new cjs.Rectangle(-667,-1054,1333,2108), null);


(lib.Robert_Front_Relieved = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Brows
	this.instance = new lib.Man1_Brow();
	this.instance.setTransform(-89.65,-109.2,1,1,-6.9994);

	this.instance_1 = new lib.Man1_Brow();
	this.instance_1.setTransform(44.95,-115.55,1,1,6.9994);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Eyes
	this.instance_2 = new lib.Eyes_Blinking();
	this.instance_2.setTransform(2.15,-65);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Base
	this.instance_3 = new lib.Man1_Front_Base();
	this.instance_3.setTransform(-220.5,-327.5);

	this.instance_4 = new lib.Shadow_Front();
	this.instance_4.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Robert_Front_Relieved, new cjs.Rectangle(-353,-327.5,700,1021.5), null);


(lib.IntrospectionButton_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("max 3 lines, lines will vertically centereddd\nmax 3 lines, lines will vertically centereddd\nmax 3 lines, lines will vertically centereddd\nmax 3 lines, lines will vertically centereddd", "37px 'Roboto'", "#333333");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 52;
	this.disabledLabelTextField.lineWidth = 856;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(59,68.15);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("max 3 lines, lines will vertically centereddd\nmax 3 lines, lines will vertically centereddd\nmax 3 lines, lines will vertically centereddd\nmax 3 lines, lines will vertically centereddd", "37px 'Roboto'", "#333333");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 52;
	this.downLabelTextField.lineWidth = 856;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(59,68.15);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("max 3 lines, lines will vertically centereddd\nmax 3 lines, lines will vertically centereddd\nmax 3 lines, lines will vertically centereddd\nmax 3 lines, lines will vertically centereddd", "37px 'Roboto'", "#333333");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 52;
	this.overLabelTextField.lineWidth = 856;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(59,68.15);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("max 3 lines, lines will vertically centereddd\nmax 3 lines, lines will vertically centereddd\nmax 3 lines, lines will vertically centereddd\nmax 3 lines, lines will vertically centereddd", "37px 'Roboto'", "#333333");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 52;
	this.upLabelTextField.lineWidth = 856;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(59,68.15);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// bg
	this.instance = new lib.IntrospectionButton();
	this.instance.setTransform(-50,0,0.8222,0.8222);

	this.instance_1 = new lib.IntrospectionButtonDown();
	this.instance_1.setTransform(-50,0,0.8222,0.8222);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},2).wait(1));

	// hit
	this.hit = new lib.buttonHitArea();
	this.hit.name = "hit";
	this.hit.setTransform(486.75,157.25,1,0.9431,0,0,0,468.7,109.5);

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-50,0,1072.1,375.8);


(lib.MultipleSelectOptionButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,selectedUp:4,selectedOver:5,selectedDown:6,selectedDisabled:7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.instance = new lib.MCOptionVinkje();
	this.instance.setTransform(-37,-27);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4).to({_off:false},0).wait(4));

	// selectedDisabledLabelTextField
	this.selectedDisabledLabelTextField = new cjs.Text("Make it more clear who is in charge of checking grammar, punctuation etc. in documents xxxxxxxxxxxxxxxxxxx", "41px 'Roboto'", "#333333");
	this.selectedDisabledLabelTextField.name = "selectedDisabledLabelTextField";
	this.selectedDisabledLabelTextField.textAlign = "center";
	this.selectedDisabledLabelTextField.lineHeight = 56;
	this.selectedDisabledLabelTextField.lineWidth = 443;
	this.selectedDisabledLabelTextField.alpha = 0.49803922;
	this.selectedDisabledLabelTextField.parent = this;
	this.selectedDisabledLabelTextField.setTransform(249.35,42.3);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField).wait(8));

	// selectedDownLabelTextField
	this.selectedDownLabelTextField = new cjs.Text("Make it more clear who is in charge of checking grammar, punctuation etc. in documents xxxxxxxxxxxxxxxxxxx", "41px 'Roboto'", "#333333");
	this.selectedDownLabelTextField.name = "selectedDownLabelTextField";
	this.selectedDownLabelTextField.textAlign = "center";
	this.selectedDownLabelTextField.lineHeight = 56;
	this.selectedDownLabelTextField.lineWidth = 443;
	this.selectedDownLabelTextField.parent = this;
	this.selectedDownLabelTextField.setTransform(249.35,42.3);
ranj.TextOffsetFixer.fix(this.selectedDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDownLabelTextField).wait(8));

	// selectedOverLabelTextField
	this.selectedOverLabelTextField = new cjs.Text("Make it more clear who is in charge of checking grammar, punctuation etc. in documents xxxxxxxxxxxxxxxxxxx", "41px 'Roboto'", "#333333");
	this.selectedOverLabelTextField.name = "selectedOverLabelTextField";
	this.selectedOverLabelTextField.textAlign = "center";
	this.selectedOverLabelTextField.lineHeight = 56;
	this.selectedOverLabelTextField.lineWidth = 443;
	this.selectedOverLabelTextField.parent = this;
	this.selectedOverLabelTextField.setTransform(249.35,42.3);
ranj.TextOffsetFixer.fix(this.selectedOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedOverLabelTextField).wait(8));

	// selectedUpLabelTextField
	this.selectedUpLabelTextField = new cjs.Text("Make it more clear who is in charge of checking grammar, punctuation etc. in documents xxxxxxxxxxxxxxxxxxx", "41px 'Roboto'", "#333333");
	this.selectedUpLabelTextField.name = "selectedUpLabelTextField";
	this.selectedUpLabelTextField.textAlign = "center";
	this.selectedUpLabelTextField.lineHeight = 56;
	this.selectedUpLabelTextField.lineWidth = 443;
	this.selectedUpLabelTextField.parent = this;
	this.selectedUpLabelTextField.setTransform(249.35,42.3);
ranj.TextOffsetFixer.fix(this.selectedUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedUpLabelTextField).wait(8));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Make it more clear who is in charge of checking grammar, punctuation etc. in documents xxxxxxxxxxxxxxxxxxx", "41px 'Roboto'", "#333333");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 56;
	this.disabledLabelTextField.lineWidth = 443;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(249.35,42.3);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(8));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Make it more clear who is in charge of checking grammar, punctuation etc. in documents xxxxxxxxxxxxxxxxxxx", "41px 'Roboto'", "#333333");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 56;
	this.downLabelTextField.lineWidth = 443;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(249.35,42.3);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(8));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Make it more clear who is in charge of checking grammar, punctuation etc. in documents xxxxxxxxxxxxxxxxxxx", "41px 'Roboto'", "#333333");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 56;
	this.overLabelTextField.lineWidth = 443;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(249.35,42.3);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(8));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Make it more clear who is in charge of checking grammar, punctuation etc. in documents xxxxxxxxxxxxxxxxxxx", "41px 'Roboto'", "#333333");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 56;
	this.upLabelTextField.lineWidth = 443;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(249.35,42.3);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(8));

	// hit
	this.hit = new lib.buttonHitArea();
	this.hit.name = "hit";
	this.hit.setTransform(245.75,139.95,0.5328,1.4065,0,0,0,461.4,100.4);

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(8));

	// Layer_1
	this.instance_1 = new lib.MCOptionUp();
	this.instance_1.setTransform(0,0,0.7821,0.7821);

	this.instance_2 = new lib.MCOptionHi();
	this.instance_2.setTransform(0,0,0.7821,0.7821);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-37,-27,535.2,385.2);


(lib.TransitionScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// titleTextField
	this.titleTextfield = new cjs.Text("Minigame Line2", "110px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.textAlign = "center";
	this.titleTextfield.lineHeight = 132;
	this.titleTextfield.lineWidth = 1018;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(0.7509,-72.8989);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// bg
	this.bg = new lib.bg_grey();
	this.bg.name = "bg";
	this.bg.setTransform(-2.65,-1.3);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TransitionScreenSkin, new cjs.Rectangle(-679.7,-1066.9,1354.1,2131.2), null);


(lib.EndScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.button = new lib.StartGameButton();
	this.button.name = "button";
	this.button.setTransform(0,691.35,2.7273,2.7273);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// bodyTextField
	this.bodyTextfield = new cjs.Text("Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here ", "40px 'Roboto'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 63;
	this.bodyTextfield.lineWidth = 875;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-431.8,-585.752);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// titleTextField
	this.titleTextfield = new cjs.Text("Life is Sweet", "108px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 130;
	this.titleTextfield.lineWidth = 867;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-431.8,-789.45);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// Layer_2
	this.elem2 = new lib.factory1_1();
	this.elem2.name = "elem2";
	this.elem2.setTransform(194.2,960.7,0.7215,0.7215,0,0,0,0.1,0.1);

	this.elem4 = new lib.GambitWWalking();
	this.elem4.name = "elem4";
	this.elem4.setTransform(-332.25,836.4,0.691,0.691,0,0,0,-0.1,0.1);

	this.elem1 = new lib.factory7_1();
	this.elem1.name = "elem1";
	this.elem1.setTransform(-90.7,472.55,0.8424,0.8424,0,0,0,0.2,0.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem1},{t:this.elem4},{t:this.elem2}]}).wait(1));

	// Layer_3
	this.instance = new lib.Ground_Iso();
	this.instance.setTransform(-667,0,1.0037,1.0037);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.bg = new lib.Background_1();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EndScreenSkin, new cjs.Rectangle(-702.4,-1054,1388.3,2598.8), null);


(lib.Robert_surprised = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.instance_1 = new lib.Robert_Front_Relieved();
	this.instance_1.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Layer_3
	this.instance_2 = new lib.Ground_Straight();
	this.instance_2.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Robert_surprised, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.ProgressDot_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {unselected:0,selected:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop()
	}
	this.frame_16 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(16).call(this.frame_16).wait(1));

	// Layer_1
	this.instance = new lib.ProgressDotTween("synched",0);
	this.instance.setTransform(0,0,0.9677,0.9677);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1.3226,scaleY:1.3226},16).wait(1));

	// Layer_4
	this.instance_1 = new lib.Dot("synched",0);
	this.instance_1.setTransform(0,0,0.6451,0.6451);
	this.instance_1.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:1.2903,scaleY:1.2903,alpha:1},16).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-20.4,-20.4,41,41);


(lib.StoryPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// toggle
	this.toggle = new lib.StoryTabButton();
	this.toggle.name = "toggle";
	this.toggle.setTransform(440.5,730.05,1.2419,1.2407,0,0,0,11.1,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.toggle).wait(5));

	// text
	this.bodyTextfield = new cjs.Text("Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here ", "40px 'Roboto'", "#333333");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 63;
	this.bodyTextfield.lineWidth = 875;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-431.8,-536.302);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.titleTextfield = new cjs.Text("The story so far", "90px 'Roboto Medium'", "#333333");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 108;
	this.titleTextfield.lineWidth = 867;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-431.8,-796.8);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.closeInstructionsTextfield = new cjs.Text("Tap to close", "24px 'Roboto Medium'", "#333333");
	this.closeInstructionsTextfield.name = "closeInstructionsTextfield";
	this.closeInstructionsTextfield.textAlign = "right";
	this.closeInstructionsTextfield.lineHeight = 29;
	this.closeInstructionsTextfield.lineWidth = 971;
	this.closeInstructionsTextfield.parent = this;
	this.closeInstructionsTextfield.setTransform(490.3999,629.1994);
ranj.TextOffsetFixer.fix(this.closeInstructionsTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.closeInstructionsTextfield},{t:this.titleTextfield},{t:this.bodyTextfield}]}).wait(5));

	// Layer_2
	this.instance = new lib.tabpanelRight();
	this.instance.setTransform(-507,-1000,0.7973,0.7728);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(5));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-507,-1000,1025.3,1777.4);


(lib.IntrospectionPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// buttons not scalable
	this.bubbles = new lib.IntrospectionThoughtBubbles();
	this.bubbles.name = "bubbles";
	this.bubbles.setTransform(708,1011.6,0.9129,0.9126,0,0,0,120.5,148.6);

	this.dialogOptionButton1 = new lib.IntrospectionButton_1();
	this.dialogOptionButton1.name = "dialogOptionButton1";
	this.dialogOptionButton1.setTransform(54.45,596.4,0.9992,0.9959);

	this.dialogOptionButton2 = new lib.IntrospectionButton_1();
	this.dialogOptionButton2.name = "dialogOptionButton2";
	this.dialogOptionButton2.setTransform(-25.55,337.35,0.9992,0.9959);

	this.dialogOptionButton3 = new lib.IntrospectionButton_1();
	this.dialogOptionButton3.name = "dialogOptionButton3";
	this.dialogOptionButton3.setTransform(50.45,76.3,0.9992,0.9959);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dialogOptionButton3},{t:this.dialogOptionButton2},{t:this.dialogOptionButton1},{t:this.bubbles}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.IntrospectionPanel, new cjs.Rectangle(-75.5,76.3,1151.2,1080.8), null);


(lib.InfoPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bioSLots
	this.ellis = new lib.BioEllis();
	this.ellis.name = "ellis";
	this.ellis.setTransform(-262.85,577.25,0.93,0.93,0,0,0,-0.6,0.8);

	this.james = new lib.BioJames();
	this.james.name = "james";
	this.james.setTransform(-262.85,426.1,0.93,0.93,0,0,0,-0.6,0.8);

	this.megan = new lib.BioMegan();
	this.megan.name = "megan";
	this.megan.setTransform(-262.85,199.1,0.93,0.93,0,0,0,-0.6,0.8);

	this.robert = new lib.BioRobert();
	this.robert.name = "robert";
	this.robert.setTransform(-262.85,-27.7,0.93,0.93,0,0,0,-0.6,0.8);

	this.player = new lib.BioGambit();
	this.player.name = "player";
	this.player.setTransform(-262.85,-254.45,0.93,0.93,0,0,0,-0.6,0.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.player},{t:this.robert},{t:this.megan},{t:this.james},{t:this.ellis}]}).wait(5));

	// toggle
	this.toggle = new lib.CastTabButton();
	this.toggle.name = "toggle";
	this.toggle.setTransform(-402.6,730,1.2419,1.2399,0,0,0,11,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.toggle).wait(5));

	// text
	this.closeInstructionsTextfield = new cjs.Text("Tap to close", "24px 'Roboto Medium'", "#333333");
	this.closeInstructionsTextfield.name = "closeInstructionsTextfield";
	this.closeInstructionsTextfield.lineHeight = 29;
	this.closeInstructionsTextfield.lineWidth = 971;
	this.closeInstructionsTextfield.parent = this;
	this.closeInstructionsTextfield.setTransform(-480.4001,624.5494);
ranj.TextOffsetFixer.fix(this.closeInstructionsTextfield);

	this.titleTextfield = new cjs.Text(".....................Meet the cast....................", "50px 'Roboto'", "#333333");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.textAlign = "center";
	this.titleTextfield.lineHeight = 66;
	this.titleTextfield.lineWidth = 891;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(21.3991,-544.35);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.episodeTitleTextfield = new cjs.Text("NameBlahBlahhh", "108px 'Roboto Medium'", "#333333");
	this.episodeTitleTextfield.name = "episodeTitleTextfield";
	this.episodeTitleTextfield.textAlign = "center";
	this.episodeTitleTextfield.lineHeight = 125;
	this.episodeTitleTextfield.lineWidth = 891;
	this.episodeTitleTextfield.parent = this;
	this.episodeTitleTextfield.setTransform(21.3991,-826.7);
ranj.TextOffsetFixer.fix(this.episodeTitleTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.episodeTitleTextfield},{t:this.titleTextfield},{t:this.closeInstructionsTextfield}]}).wait(5));

	// Layer_2
	this.instance = new lib.tabpanelLeft();
	this.instance.setTransform(-507,-1000,0.7973,0.7728);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(5));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-507,-1000,1025.3,1777.4);


(lib.FeedbackPopupBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.bgRight = new lib.FeedbackPopupBG_Right();
	this.bgRight.name = "bgRight";
	this.bgRight.setTransform(200.5,37.5,1,1,0,0,0,25,37.5);

	this.bgMid = new lib.FeedbackPopupBG_Middle();
	this.bgMid.name = "bgMid";
	this.bgMid.setTransform(113,37.5,1,1,0,0,0,63,37.5);

	this.bgLeft = new lib.FeedbackPopupBG_Left();
	this.bgLeft.name = "bgLeft";
	this.bgLeft.setTransform(25.5,37.5,1,1,0,0,0,25,37.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bgLeft},{t:this.bgMid},{t:this.bgRight}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG, new cjs.Rectangle(0.5,0,225,75), null);


(lib.FeedbackPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// body
	this.bodyTextfield = new cjs.Text("abcdef ", "italic 40px 'Roboto'", "#333333");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.textAlign = "center";
	this.bodyTextfield.lineHeight = 49;
	this.bodyTextfield.lineWidth = 149;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-0.7498,9.8);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// Layer_2
	this.bg = new lib.FeedbackPopupBG();
	this.bg.name = "bg";
	this.bg.setTransform(-2,34.25,1,1,0,0,0,112,37.5);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPanel, new cjs.Rectangle(-113.5,-3.2,225,78.4), null);


(lib.MultipleSelectionPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.submitButton = new lib.StartGameButtonFat();
	this.submitButton.name = "submitButton";
	this.submitButton.setTransform(770.5,821.3,3,3,0,0,0,0,3.1);

	this.MSOptionButton6 = new lib.MultipleSelectOptionButton();
	this.MSOptionButton6.name = "MSOptionButton6";
	this.MSOptionButton6.setTransform(829.2,590.1,1,1,0,0,0,318.5,229);

	this.MSOptionButton5 = new lib.MultipleSelectOptionButton();
	this.MSOptionButton5.name = "MSOptionButton5";
	this.MSOptionButton5.setTransform(318.5,590.1,1,1,0,0,0,318.5,229);

	this.MSOptionButton4 = new lib.MultipleSelectOptionButton();
	this.MSOptionButton4.name = "MSOptionButton4";
	this.MSOptionButton4.setTransform(829.2,223.55,1,1,0,0,0,318.5,229);

	this.MSOptionButton3 = new lib.MultipleSelectOptionButton();
	this.MSOptionButton3.name = "MSOptionButton3";
	this.MSOptionButton3.setTransform(318.5,223.55,1,1,0,0,0,318.5,229);

	this.MSOptionButton2 = new lib.MultipleSelectOptionButton();
	this.MSOptionButton2.name = "MSOptionButton2";
	this.MSOptionButton2.setTransform(829.2,-143,1,1,0,0,0,318.5,229);

	this.MSOptionButton1 = new lib.MultipleSelectOptionButton();
	this.MSOptionButton1.name = "MSOptionButton1";
	this.MSOptionButton1.setTransform(318.5,-143,1,1,0,0,0,318.5,229);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.MSOptionButton1},{t:this.MSOptionButton2},{t:this.MSOptionButton3},{t:this.MSOptionButton4},{t:this.MSOptionButton5},{t:this.MSOptionButton6},{t:this.submitButton}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MultipleSelectionPanel, new cjs.Rectangle(-1,-375.6,1013.8,1309.3000000000002), null);


(lib.PrevButton_dark = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 17;
	this.upLabelTextField.lineWidth = 73;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-22.25,-9.7);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 17;
	this.overLabelTextField.lineWidth = 73;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-22.25,-9.7);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 17;
	this.downLabelTextField.lineWidth = 73;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-22.25,-9.7);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 17;
	this.disabledLabelTextField.lineWidth = 73;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-22.25,-9.7);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.PrevNextButton();
	this.instance.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.instance_1 = new lib.PrevNextButton_down();
	this.instance_1.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.instance_2 = new lib.PrevNextButton_disabled();
	this.instance_2.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// Background
	this.bg = new lib.FeedbackPopupBG_dark();
	this.bg.name = "bg";
	this.bg.setTransform(-39.85,-2.25,0.5708,0.5697,0,0,0,111,33.1);
	this.bg.alpha = 0.8008;

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-103.2,-21.1,129,42.8);


(lib.PrevButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 17;
	this.upLabelTextField.lineWidth = 73;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-56.45,-9);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 17;
	this.overLabelTextField.lineWidth = 73;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-56.45,-9);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 17;
	this.downLabelTextField.lineWidth = 73;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-56.45,-9);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 17;
	this.disabledLabelTextField.lineWidth = 73;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-56.45,-9);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.PrevNextButton();
	this.instance.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.instance_1 = new lib.PrevNextButton_down();
	this.instance_1.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.instance_2 = new lib.PrevNextButton_disabled();
	this.instance_2.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(-40.75,0.3);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-102,-17.9,122.5,36.5);


(lib.NextButton_dark = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 17;
	this.upLabelTextField.lineWidth = 73;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-56.05,-9.9);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 17;
	this.overLabelTextField.lineWidth = 73;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-56.05,-9.9);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 17;
	this.downLabelTextField.lineWidth = 73;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-56.05,-9.9);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 17;
	this.disabledLabelTextField.lineWidth = 73;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-56.05,-9.9);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.PrevNextButton();
	this.instance.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.instance_1 = new lib.PrevNextButton_down();
	this.instance_1.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.instance_2 = new lib.PrevNextButton_disabled();
	this.instance_2.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(-40.75,0.3);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	// Background
	this.bg = new lib.FeedbackPopupBG_dark();
	this.bg.name = "bg";
	this.bg.setTransform(-39.85,-2.25,0.5708,0.5697,0,0,0,111,33.1);
	this.bg.alpha = 0.8008;

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-103.2,-21.1,129,42.8);


(lib.NextButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "right";
	this.upLabelTextField.lineHeight = 17;
	this.upLabelTextField.lineWidth = 73;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-21.6,-9);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "right";
	this.overLabelTextField.lineHeight = 17;
	this.overLabelTextField.lineWidth = 73;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-21.6,-9);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "right";
	this.downLabelTextField.lineHeight = 17;
	this.downLabelTextField.lineWidth = 73;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-21.6,-9);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "right";
	this.disabledLabelTextField.lineHeight = 17;
	this.disabledLabelTextField.lineWidth = 73;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-21.6,-9);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.PrevNextButton();
	this.instance.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.instance_1 = new lib.PrevNextButton_down();
	this.instance_1.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.instance_2 = new lib.PrevNextButton_disabled();
	this.instance_2.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(-40.75,0.3);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-102,-17.9,122.5,36.5);


(lib.EpisodeButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// imageContainer
	this.imageContainer = new lib.EpisodeImages();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(360,-18,0.7317,0.7317);

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(4));

	// completedTextField
	this.completedTextField = new cjs.Text("Completed", "41px 'Roboto'", "#333333");
	this.completedTextField.name = "completedTextField";
	this.completedTextField.lineHeight = 59;
	this.completedTextField.lineWidth = 781;
	this.completedTextField.alpha = 0.49803922;
	this.completedTextField.parent = this;
	this.completedTextField.setTransform(-334.45,-7.1);
	this.completedTextField._off = true;
ranj.TextOffsetFixer.fix(this.completedTextField);

	this.timeline.addTween(cjs.Tween.get(this.completedTextField).wait(3).to({_off:false},0).wait(1));

	// vinkje
	this.instance = new lib.MCOptionVinkje();
	this.instance.setTransform(-448,-60);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(3).to({_off:false},0).wait(1));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Dissatisfaction", "64px 'Roboto Medium'", "#333333");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 82;
	this.disabledLabelTextField.lineWidth = 781;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-334.45,-71.1);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextfield
	this.downLabelTextField = new cjs.Text("Dissatisfaction", "64px 'Roboto Medium'", "#333333");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 82;
	this.downLabelTextField.lineWidth = 781;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-334.45,-59.1);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextfield
	this.overLabelTextField = new cjs.Text("Dissatisfaction", "64px 'Roboto Medium'", "#333333");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 82;
	this.overLabelTextField.lineWidth = 781;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-334.45,-59.1);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextfield
	this.upLabelTextField = new cjs.Text("Dissatisfaction", "64px 'Roboto Medium'", "#333333");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 82;
	this.upLabelTextField.lineWidth = 781;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-334.45,-59.1);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// bg
	this.instance_1 = new lib.EpisodeSelectButtonUp();
	this.instance_1.setTransform(-488,-119,0.8182,0.8182);

	this.instance_2 = new lib.EpisodeSelectButtonHi();
	this.instance_2.setTransform(-488,-119,0.8182,0.8182);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-488,-119,975.3,198);


(lib.AssetsButtonsDialogButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabled
	this.disabled = new lib.ConversationScalableButtonDisabled();
	this.disabled.name = "disabled";
	this.disabled.setTransform(-4.1,0.5,1,1,0,0,0,512.9,116.5);

	this.timeline.addTween(cjs.Tween.get(this.disabled).wait(1));

	// down
	this.down = new lib.ConversationScalableButtonDown();
	this.down.name = "down";
	this.down.setTransform(-4.1,0.5,1,1,0,0,0,512.9,116.5);

	this.timeline.addTween(cjs.Tween.get(this.down).wait(1));

	// over
	this.over = new lib.ConversationScalableButtonOver();
	this.over.name = "over";
	this.over.setTransform(-4.1,0.5,1,1,0,0,0,512.9,116.5);

	this.timeline.addTween(cjs.Tween.get(this.over).wait(1));

	// up
	this.up = new lib.ConversationScalableButtonUp();
	this.up.name = "up";
	this.up.setTransform(-4.1,0.5,1,1,0,0,0,512.9,116.5);

	this.timeline.addTween(cjs.Tween.get(this.up).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.AssetsButtonsDialogButton, new cjs.Rectangle(-512,-116,1026,162), null);


(lib.BalloonInfo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// text
	this.bodyTextfield = new cjs.Text("[introductory remarks in this balloon]\nline2\nline3\nline4\nline5", "italic 40px 'Roboto'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 50;
	this.bodyTextfield.lineWidth = 923;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-456.45,-116.3);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// bg
	this.bg = new lib.BalloonInfoBG();
	this.bg.name = "bg";
	this.bg.setTransform(6.95,-147.45,1,1,0,0,0,0,-152);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BalloonInfo, new cjs.Rectangle(-503,-148,1020,305.2), null);


(lib.StoryPanelSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// content (closed)
	this.contents = new lib.StoryPanel();
	this.contents.name = "contents";
	this.contents.setTransform(2.95,-1537.15,1,1,0,0,0,0.5,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.contents).wait(1));

	// bg
	this.bg = new lib.DarkTransparentBackground();
	this.bg.name = "bg";
	this.bg.setTransform(-0.95,102.5);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.StoryPanelSkin, new cjs.Rectangle(-676.4,-2537,1755.8000000000002,3841.2), null);


(lib.IntroScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// texts
	this.textPanel = new lib.IntroScreenTexts();
	this.textPanel.name = "textPanel";
	this.textPanel.setTransform(7.45,-20.35);

	this.timeline.addTween(cjs.Tween.get(this.textPanel).wait(3));

	// button start
	this.button = new lib.StartGameButtonFat();
	this.button.name = "button";
	this.button.setTransform(314.8,727.75,2.7273,2.7273);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(3));

	// button next
	this.nextButton = new lib.NextButton_dark();
	this.nextButton.name = "nextButton";
	this.nextButton.setTransform(312.85,726.8,3,3,0,0,0,-38.7,0.1);

	this.timeline.addTween(cjs.Tween.get(this.nextButton).wait(3));

	// button prev
	this.prevButton = new lib.PrevButton_dark();
	this.prevButton.name = "prevButton";
	this.prevButton.setTransform(-307.4,726.8,3,3,0,0,0,-41,0.1);

	this.timeline.addTween(cjs.Tween.get(this.prevButton).wait(3));

	// Layer_2
	this.elem2 = new lib.factory1_1();
	this.elem2.name = "elem2";
	this.elem2.setTransform(184.55,852.25,0.7215,0.7215,0,0,0,0.1,0.1);

	this.elem4 = new lib.factory3_1();
	this.elem4.name = "elem4";
	this.elem4.setTransform(-316.85,672.7,0.7215,0.7215);

	this.elem10 = new lib.Gambit();
	this.elem10.name = "elem10";
	this.elem10.setTransform(-104.1,561.75,0.5918,0.5918,0,0,0,0,0.1);

	this.elem7 = new lib.chimney();
	this.elem7.name = "elem7";
	this.elem7.setTransform(-782.55,497.25,0.7215,0.7215,0,0,0,-0.1,0.2);

	this.elem6 = new lib.factory4_1();
	this.elem6.name = "elem6";
	this.elem6.setTransform(96.2,356,0.7215,0.7215,0,0,0,0.2,0.1);

	this.elem8 = new lib.chimney();
	this.elem8.name = "elem8";
	this.elem8.setTransform(807.85,192,0.606,0.606,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem8},{t:this.elem6},{t:this.elem7},{t:this.elem10},{t:this.elem4},{t:this.elem2}]}).wait(3));

	// Layer_3
	this.instance = new lib.Ground_Iso();
	this.instance.setTransform(-667,75,1.0037,1.0037);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(3));

	// bg
	this.bg = new lib.Background_1();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(3));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-832.6,-1054,1824.6,2888.3);


(lib.InfoPanelSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// content (closed)
	this.contents = new lib.InfoPanel();
	this.contents.name = "contents";
	this.contents.setTransform(0.5,-1540.15,1,1,0,0,0,0.5,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.contents).wait(1));

	// bg
	this.bg = new lib.DarkTransparentBackground();
	this.bg.name = "bg";
	this.bg.setTransform(-0.95,102.5);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.InfoPanelSkin, new cjs.Rectangle(-676.4,-2540,1350.9,3844.2), null);


(lib.EpisodeSelectionScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.episodeButton = new lib.EpisodeButton();
	this.episodeButton.name = "episodeButton";
	this.episodeButton.setTransform(0,-230);

	this.timeline.addTween(cjs.Tween.get(this.episodeButton).wait(1));

	// bodyTextField
	this.bodyTextfield = new cjs.Text("Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here ", "40px 'Roboto'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 63;
	this.bodyTextfield.lineWidth = 875;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-431.8,-746.752);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// Layer_2
	this.instance = new lib.factory1_1();
	this.instance.setTransform(184.55,852.25,0.7215,0.7215,0,0,0,0.1,0.1);

	this.instance_1 = new lib.factory3_1();
	this.instance_1.setTransform(-316.85,672.7,0.7215,0.7215);

	this.instance_2 = new lib.Gambit();
	this.instance_2.setTransform(-104.1,561.75,0.5918,0.5918,0,0,0,0,0.1);

	this.instance_3 = new lib.chimney();
	this.instance_3.setTransform(-770.55,483.4,0.7215,0.7215,0,0,0,-0.1,0.2);

	this.instance_4 = new lib.factory4_1();
	this.instance_4.setTransform(96.2,356,0.7215,0.7215,0,0,0,0.2,0.1);

	this.instance_5 = new lib.chimney();
	this.instance_5.setTransform(825.8,190,0.606,0.606,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Layer_3
	this.instance_6 = new lib.Ground_Iso();
	this.instance_6.setTransform(-667,39,1.0037,1.0037);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(1));

	// bg
	this.bg = new lib.Background_1();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EpisodeSelectionScreenSkin, new cjs.Rectangle(-820.6,-1054,1688.5,2637.8), null);


(lib.ProgressDots_MC = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.dot3 = new lib.ProgressDot_1();
	this.dot3.name = "dot3";
	this.dot3.setTransform(47.85,0);

	this.dot1 = new lib.ProgressDot_1();
	this.dot1.name = "dot1";
	this.dot1.setTransform(-48.15,0);

	this.dot2 = new lib.ProgressDot_1();
	this.dot2.name = "dot2";
	this.dot2.setTransform(-0.15,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dot2},{t:this.dot1},{t:this.dot3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ProgressDots_MC, new cjs.Rectangle(-63.1,-15,126,30), null);


(lib.DialogPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// |Dialog
	this.dialogOptionButton1 = new lib.AssetsButtonsDialogButton();
	this.dialogOptionButton1.name = "dialogOptionButton1";
	this.dialogOptionButton1.setTransform(499.7,583.75);

	this.dialogOptionButton2 = new lib.AssetsButtonsDialogButton();
	this.dialogOptionButton2.name = "dialogOptionButton2";
	this.dialogOptionButton2.setTransform(499.7,416.85);

	this.dialogOptionButton3 = new lib.AssetsButtonsDialogButton();
	this.dialogOptionButton3.name = "dialogOptionButton3";
	this.dialogOptionButton3.setTransform(499.7,251.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dialogOptionButton3},{t:this.dialogOptionButton2},{t:this.dialogOptionButton1}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DialogPanel, new cjs.Rectangle(-12.3,135.5,1026,494.29999999999995), null);


(lib.TutorialScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button start
	this.button = new lib.StartGameButton_Overlay();
	this.button.name = "button";
	this.button.setTransform(317.2,757.55,2.3939,2.3939,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(4));

	// buttons
	this.prevButton = new lib.PrevButton();
	this.prevButton.name = "prevButton";
	this.prevButton.setTransform(-276.5,757.55,3,3,0,0,0,-41,0.1);

	this.nextButton = new lib.NextButton();
	this.nextButton.name = "nextButton";
	this.nextButton.setTransform(236.25,757.55,3,3,0,0,0,-38.7,0.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.nextButton},{t:this.prevButton}]}).wait(4));

	// Progress dots
	this.progressDots = new lib.ProgressDots_MC();
	this.progressDots.name = "progressDots";
	this.progressDots.setTransform(-7.65,756.9,0.9,0.9,0,0,0,-0.1,0);

	this.timeline.addTween(cjs.Tween.get(this.progressDots).wait(4));

	// Titles
	this.titleTextfield = new cjs.Text("xMaking decisions", "20px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 24;
	this.titleTextfield.lineWidth = 283;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-423.5,-708,3,3);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(4));

	// Text
	this.bodyTextfield = new cjs.Text("• xAt certain moments you are asked to make a choice out of multiple options.", "14px 'Roboto'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 18;
	this.bodyTextfield.lineWidth = 282;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-423.5,-540.2,3,3);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(4));

	// bg1
	this.bg1 = new lib.TutorialBackgroundBird();
	this.bg1.name = "bg1";
	this.bg1.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg1).wait(4));

	// bg2
	this.bg2 = new lib.TutorialBackgroundCharacter();
	this.bg2.name = "bg2";
	this.bg2.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg2).wait(4));

	// bg3
	this.bg3 = new lib.TutorialBackgroundScore();
	this.bg3.name = "bg3";
	this.bg3.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg3).wait(4));

	// tutorialDialogPanel
	this.tutorialDialogPanel = new lib.DialogPanel();
	this.tutorialDialogPanel.name = "tutorialDialogPanel";
	this.tutorialDialogPanel.setTransform(-498.85,20.15);

	this.timeline.addTween(cjs.Tween.get(this.tutorialDialogPanel).wait(4));

	// npcTextPanel
	this.npcBalloon = new lib.BalloonNPCtutorial();
	this.npcBalloon.name = "npcBalloon";
	this.npcBalloon.setTransform(-8.6,-419.65);

	this.timeline.addTween(cjs.Tween.get(this.npcBalloon).wait(4));

	// Gamescreen
	this.contents = new lib.InfoPanel();
	this.contents.name = "contents";
	this.contents.setTransform(-5.15,-1537.15,1,1,0,0,0,0.5,-0.1);

	this.contents_1 = new lib.StoryPanel();
	this.contents_1.name = "contents_1";
	this.contents_1.setTransform(-5.15,-1537.15,1,1,0,0,0,0.5,-0.1);

	this.instance = new lib.Robert_surprised();
	this.instance.setTransform(-3.5,67,1,1,0,0,0,-2,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.contents_1},{t:this.contents}]}).wait(4));

	// imageContainer
	this.imageContainer = new lib.PlaceholderRound();
	this.imageContainer.name = "imageContainer";

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(4));

	// bg
	this.bg = new lib.Background_1();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-795.5,-2539.9,1874.9,4363.1);


(lib.DialogScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// MultipleSelection
	this.multipleSelectionPanel = new lib.MultipleSelectionPanel();
	this.multipleSelectionPanel.name = "multipleSelectionPanel";
	this.multipleSelectionPanel.setTransform(0.05,55.95,1,1,0,0,0,500.7,128.8);

	this.timeline.addTween(cjs.Tween.get(this.multipleSelectionPanel).wait(1));

	// infoballoon (premise)
	this.infoBalloon = new lib.BalloonInfo();
	this.infoBalloon.name = "infoBalloon";
	this.infoBalloon.setTransform(-3.9,-565.9);

	this.timeline.addTween(cjs.Tween.get(this.infoBalloon).wait(1));

	// IntrospectionPanel
	this.introspectionPanel = new lib.IntrospectionPanel();
	this.introspectionPanel.name = "introspectionPanel";
	this.introspectionPanel.setTransform(-498.85,-685.65);

	this.timeline.addTween(cjs.Tween.get(this.introspectionPanel).wait(1));

	// DialogPanel
	this.dialogPanel = new lib.DialogPanel();
	this.dialogPanel.name = "dialogPanel";
	this.dialogPanel.setTransform(-498.85,203.15);

	this.timeline.addTween(cjs.Tween.get(this.dialogPanel).wait(1));

	// continueButton
	this.continueButton = new lib.StartGameButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(0,691.5,3,3,0,0,0,0,3.1);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// npcTextPanel
	this.npcBalloon = new lib.BalloonNPC();
	this.npcBalloon.name = "npcBalloon";
	this.npcBalloon.setTransform(-8.6,-419.65);

	this.timeline.addTween(cjs.Tween.get(this.npcBalloon).wait(1));

	// imageContainer
	this.imageContainer = new lib.PlaceholderRound();
	this.imageContainer.name = "imageContainer";

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	// bg
	this.bg = new lib.Background_1();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DialogScreenSkin, new cjs.Rectangle(-676.4,-2539.9,1351,3844.1000000000004), null);


// stage content:
(lib.MainAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// assets
	this.feedbackPanel = new lib.FeedbackPanel();
	this.feedbackPanel.name = "feedbackPanel";
	this.feedbackPanel.setTransform(1525.85,-771,1,1,0,0,0,-3.5,31.4);

	this.timeline.addTween(cjs.Tween.get(this.feedbackPanel).wait(1));

	// episopdeselectscreen
	this.instance = new lib.EpisodeSelectionScreenSkin();
	this.instance.setTransform(-2690.55,1166.6,1,1,0,0,0,1,308.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// contextual info
	this.rulesPanel = new lib.InfoPanelSkin();
	this.rulesPanel.name = "rulesPanel";
	this.rulesPanel.setTransform(3404.35,630.65,1,1,0,0,0,0,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.rulesPanel).wait(1));

	// tutorialScreen
	this.instance_1 = new lib.TutorialScreenSkin();
	this.instance_1.setTransform(-4384.25,538.35,1,1,0,0,0,-62,-358.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// story info
	this.instance_2 = new lib.StoryPanelSkin();
	this.instance_2.setTransform(3403.35,27.05,1,1,0,0,0,-1,-604.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// dialogscreen
	this.instance_3 = new lib.DialogScreenSkin();
	this.instance_3.setTransform(963.9,1266.05,1,1,0,0,0,423.9,395);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// transitionscreen
	this.instance_4 = new lib.TransitionScreenSkin();
	this.instance_4.setTransform(2054.05,870.95,1,1,0,0,0,0.5,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	// introscreen
	this.instance_5 = new lib.IntroScreenSkin();
	this.instance_5.setTransform(-1042.6,3100.55,1,1,0,0,0,-0.6,0);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(1));

	// endscreen
	this.instance_6 = new lib.EndScreenSkin();
	this.instance_6.setTransform(-1041.5,870.95,1,1,0,0,0,0.5,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-4577.7,-1037.8,8656.6,5758.1);
// library properties:
lib.properties = {
	id: 'F7DD7F692B0D1D44A7B614DFFAE812BF',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#666666",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/MainAssets/Andrea_Side_Neutral_Open.png", id:"MainAssets_Andrea_Side_Neutral_Open", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Background_Blue.png", id:"MainAssets_Background_Blue", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Balloon01.png", id:"MainAssets_Balloon01", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/bubbles.png", id:"MainAssets_bubbles", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_disabled.png", id:"MainAssets_Button_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_down.png", id:"MainAssets_Button_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_up.png", id:"MainAssets_Button_up", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ButtonFat_disabled.png", id:"MainAssets_ButtonFat_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ButtonFat_down.png", id:"MainAssets_ButtonFat_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ButtonFat_up.png", id:"MainAssets_ButtonFat_up", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CharacterShadow.png", id:"MainAssets_CharacterShadow", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/DialogButton_down.png", id:"MainAssets_DialogButton_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/DialogButton_up.png", id:"MainAssets_DialogButton_up", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode1Image.png", id:"MainAssets_Episode1Image", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode1ImageDone.png", id:"MainAssets_Episode1ImageDone", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode2Image.png", id:"MainAssets_Episode2Image", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode2ImageDone.png", id:"MainAssets_Episode2ImageDone", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/episode3Image.png", id:"MainAssets_episode3Image", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode3ImageDOne.png", id:"MainAssets_Episode3ImageDOne", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode4Image.png", id:"MainAssets_Episode4Image", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode4ImageDone.png", id:"MainAssets_Episode4ImageDone", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode5Image.png", id:"MainAssets_Episode5Image", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode5ImageDone.png", id:"MainAssets_Episode5ImageDone", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/EpisodeSelectButtonHi.png", id:"MainAssets_EpisodeSelectButtonHi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/EpisodeSelectButtonUp.png", id:"MainAssets_EpisodeSelectButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Eye_Front_Open.png", id:"MainAssets_Eye_Front_Open", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/factory1.png", id:"MainAssets_factory1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/factory2.png", id:"MainAssets_factory2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/factory3.png", id:"MainAssets_factory3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/factory4.png", id:"MainAssets_factory4", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/factory7.png", id:"MainAssets_factory7", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Left.png", id:"MainAssets_FeedbackPopup_Left", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Middle.png", id:"MainAssets_FeedbackPopup_Middle", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Right.png", id:"MainAssets_FeedbackPopup_Right", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopupBG_dark_1.png", id:"MainAssets_FeedbackPopupBG_dark_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/gambit.png", id:"MainAssets_gambit", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/gambit_1.png", id:"MainAssets_gambit_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Gambit_Back.png", id:"MainAssets_Gambit_Back", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/gambit_closed.png", id:"MainAssets_gambit_closed", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/gambitWalking2.png", id:"MainAssets_gambitWalking2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Ground_Iso.png", id:"MainAssets_Ground_Iso", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Ground_Straight.png", id:"MainAssets_Ground_Straight", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/IntrospectionButton.png", id:"MainAssets_IntrospectionButton", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/IntrospectionButtonDown.png", id:"MainAssets_IntrospectionButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Man1_Brow.png", id:"MainAssets_Man1_Brow", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Man1_Front_Base.png", id:"MainAssets_Man1_Front_Base", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MCOptionHi.png", id:"MainAssets_MCOptionHi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MCOptionUp.png", id:"MainAssets_MCOptionUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MCOptionVinkje.png", id:"MainAssets_MCOptionVinkje", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Megan_Side_Neutral_Open.png", id:"MainAssets_Megan_Side_Neutral_Open", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Narration01.png", id:"MainAssets_Narration01", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Paul_Side_Neutral_Open.png", id:"MainAssets_Paul_Side_Neutral_Open", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton.png", id:"MainAssets_PrevNextButton", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_disabled.png", id:"MainAssets_PrevNextButton_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_down.png", id:"MainAssets_PrevNextButton_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProgressDot.png", id:"MainAssets_ProgressDot", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProgressDot_Selected.png", id:"MainAssets_ProgressDot_Selected", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Robert_Side_Neutral_Open.png", id:"MainAssets_Robert_Side_Neutral_Open", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Shadow_Front.png", id:"MainAssets_Shadow_Front", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/tabButtonLeft.png", id:"MainAssets_tabButtonLeft", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/tabButtonLeftDisabled.png", id:"MainAssets_tabButtonLeftDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/tabButtonLeftHi.png", id:"MainAssets_tabButtonLeftHi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/tabButtonRight.png", id:"MainAssets_tabButtonRight", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/tabButtonRightDisabled.png", id:"MainAssets_tabButtonRightDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/tabButtonRightHi.png", id:"MainAssets_tabButtonRightHi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/tabCastIcon.png", id:"MainAssets_tabCastIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/tabpanelLeft.png", id:"MainAssets_tabpanelLeft", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/tabpanelRight.png", id:"MainAssets_tabpanelRight", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/tabStoryIcon.png", id:"MainAssets_tabStoryIcon", bundle:"MainAssets"}
	],
	preloads: []
};



})(lib.MainAssets = {}, images, ss, createjs);
module.exports = lib.MainAssets;